import "./style.css";
import React from "react";

import Container from "components/Container";

import { ToastContainer, toast, Bounce } from "react-toastify";
import { useForm } from "@formspree/react";


export default function ContactForm() {
	const [state, handleSubmit] = useForm(process.env.REACT_APP_FORM_ID);

	function clearFormInputs(event) {
		event.target[0].value = "";
		event.target[1].value = "";
		event.target[2].value = "";
	}

	if (state.succeeded) {
		console.log("");
	}

	function formSubmit(event) {
		event.preventDefault();
		handleSubmit(event).then(
			() => {
				toast.success("Ditt meddelande har skickats, tack!", {
					position: "top-center",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: false,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",
					transition: Bounce,
				});
				clearFormInputs(event);
			},
			() => {
				toast.error(
					"Det gick inte att skicka ditt meddelande, försök igen.",
					{
						position: "top-center",
						autoClose: 5000,
						hideProgressBar: false,
						closeOnClick: false,
						pauseOnHover: true,
						draggable: true,
						progress: undefined,
						theme: "colored",
						transition: Bounce,
					}
				);
			}
		);
	}

	return (
		<Container containerClass="contact-form-container">
			<ToastContainer className="toast" />
			<form className="contact-form" onSubmit={formSubmit}>
				<p className="contact-form-title">kontakta mig</p>
				<Container containerClass="contact-form-input-container">
					<input
						className="contact-form-input-name"
						type="text"
						placeholder="Namn"
						id="name"
						name="name"
						required
					/>
					<input
						className="contact-form-input-email"
						type="email"
						placeholder="E-post"
						id="email"
						name="email"
						required
					/>
					<textarea
						className="contact-form-textarea"
						placeholder="Meddelande"
						id="message"
						name="message"
						required
					/>
				</Container>
				<input type="submit" className="input expand-xs" />
			</form>
		</Container>
	);
}
